import {
  IRecognitionCameraConfigUpdateParams,
  IRecognitionCameraCreateProps,
  IRecognitionCameraFilterProps,
  IRecognitionCameraGetAllParams,
  IRecognitionCameraGroupProps,
  IRecognitionCameraProps,
  IRecognitionCameraSimpleProps,
  IRecognitionCameraUpdateParams,
} from './types';
import { api } from '../../../../../DefaultService';
import { IPaginationParams } from '../../../../../types';

const ENDPOINT = 'v1/devices/cameras/faceRecognition';

export const createRecognitionCameraAsync = async (
  data: IRecognitionCameraCreateProps,
): Promise<IRecognitionCameraProps> => {
  return await api
    .post(ENDPOINT, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getRecognitionCameraByIdAsync = async (
  id: number,
): Promise<IRecognitionCameraProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllRecognitionCameraByLicenseAsync = async ({
  pagination,
  filter,
}: IRecognitionCameraGetAllParams): Promise<
  IRecognitionCameraSimpleProps[]
> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`, {
      params: { ...pagination, ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllRecognitionCameraCountByLicenseAsync = async (
  filter?: IRecognitionCameraFilterProps,
): Promise<number> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense/count`, {
      params: { ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateRecognitionCameraAsync = async ({
  id,
  data,
}: IRecognitionCameraUpdateParams): Promise<IRecognitionCameraProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteRecognitionCameraAsync = async (
  id: number,
): Promise<void> => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const getRecognitionCameraGroupsAsync = async (
  id: number,
): Promise<IRecognitionCameraGroupProps[]> => {
  return await api
    .get(`${ENDPOINT}/${id}/group`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateConfigRecognitionCameraAsync = async ({
  id,
  data,
}: IRecognitionCameraConfigUpdateParams): Promise<void> => {
  await api.put(`${ENDPOINT}/${id}/config`, data).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const getRecognitionCamerasByIdsAsync = async (
  ids: number[],
): Promise<IRecognitionCameraSimpleProps[]> => {
  const converted = ids.join(',');
  return await api
    .get(`${ENDPOINT}/getByIds`, {
      params: { ids: converted },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
